var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Complex } from '@syncfusion/ej2-base';
import { Border } from '../../common/model/base';
import { BulletChartTheme } from '../utils/theme';
/**
 * Configuration of the bullet chart ranges
 */
export class Range extends ChildProperty {
}
__decorate([
    Property(null)
], Range.prototype, "end", void 0);
__decorate([
    Property(1)
], Range.prototype, "opacity", void 0);
__decorate([
    Property(null)
], Range.prototype, "color", void 0);
/**
 * Configures the major tick lines.
 */
export class MajorTickLinesSettings extends ChildProperty {
}
__decorate([
    Property(12)
], MajorTickLinesSettings.prototype, "height", void 0);
__decorate([
    Property(1)
], MajorTickLinesSettings.prototype, "width", void 0);
__decorate([
    Property(null)
], MajorTickLinesSettings.prototype, "color", void 0);
__decorate([
    Property(false)
], MajorTickLinesSettings.prototype, "useRangeColor", void 0);
/**
 * Configures the minor tick lines.
 */
export class MinorTickLinesSettings extends ChildProperty {
}
__decorate([
    Property(8)
], MinorTickLinesSettings.prototype, "height", void 0);
__decorate([
    Property(1)
], MinorTickLinesSettings.prototype, "width", void 0);
__decorate([
    Property(null)
], MinorTickLinesSettings.prototype, "color", void 0);
__decorate([
    Property(false)
], MinorTickLinesSettings.prototype, "useRangeColor", void 0);
/**
 * Configures the fonts in bullet chart.
 */
export class BulletLabelStyle extends ChildProperty {
}
__decorate([
    Property('Normal')
], BulletLabelStyle.prototype, "fontStyle", void 0);
__decorate([
    Property('16px')
], BulletLabelStyle.prototype, "size", void 0);
__decorate([
    Property('')
], BulletLabelStyle.prototype, "color", void 0);
__decorate([
    Property('Normal')
], BulletLabelStyle.prototype, "fontWeight", void 0);
__decorate([
    Property('Segoe UI')
], BulletLabelStyle.prototype, "fontFamily", void 0);
__decorate([
    Property('Center')
], BulletLabelStyle.prototype, "textAlignment", void 0);
__decorate([
    Property('None')
], BulletLabelStyle.prototype, "textOverflow", void 0);
__decorate([
    Property(1)
], BulletLabelStyle.prototype, "opacity", void 0);
__decorate([
    Property(true)
], BulletLabelStyle.prototype, "enableTrim", void 0);
__decorate([
    Property(null)
], BulletLabelStyle.prototype, "maximumTitleWidth", void 0);
__decorate([
    Property(false)
], BulletLabelStyle.prototype, "useRangeColor", void 0);
/**
 * Configures the ToolTips in the bullet chart.
 */
export class BulletTooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], BulletTooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], BulletTooltipSettings.prototype, "fill", void 0);
__decorate([
    Complex(BulletChartTheme.tooltipLabelFont, BulletLabelStyle)
], BulletTooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Complex({ color: '#cccccc', width: 0.5 }, Border)
], BulletTooltipSettings.prototype, "border", void 0);
__decorate([
    Property(null)
], BulletTooltipSettings.prototype, "template", void 0);
/**
 * Configures the DataLabel in the bullet chart.
 */
export class BulletDataLabel extends ChildProperty {
}
__decorate([
    Property(false)
], BulletDataLabel.prototype, "enable", void 0);
__decorate([
    Complex(BulletChartTheme.dataLabelFont, BulletLabelStyle)
], BulletDataLabel.prototype, "labelStyle", void 0);
